var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWork2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.0833 15.6654H26.6333C20.0527 15.6654 16.7624 15.6654 14.249 16.9461C12.0381 18.0726 10.2405 19.8702 9.11402 22.0811C7.83334 24.5945 7.83334 27.8848 7.83334 34.4654V67.3654C7.83334 73.9461 7.83334 77.2364 9.11402 79.7498C10.2405 81.9607 12.0381 83.7583 14.249 84.8848C16.7624 86.1654 20.0527 86.1654 26.6333 86.1654H59.5333C66.114 86.1654 69.4043 86.1654 71.9177 84.8848C74.1286 83.7583 75.9262 81.9607 77.0527 79.7498C78.3333 77.2364 78.3333 73.9461 78.3333 67.3654V50.9154M31.3332 62.6654H37.8919C39.8078 62.6654 40.7658 62.6654 41.6673 62.449C42.4666 62.2571 43.2307 61.9406 43.9316 61.5111C44.7221 61.0267 45.3995 60.3493 46.7543 58.9945L84.2083 21.5404C87.453 18.2958 87.453 13.0351 84.2083 9.79044C80.9637 6.54577 75.703 6.54576 72.4583 9.79043L35.0042 47.2445C33.6494 48.5993 32.972 49.2767 32.4876 50.0672C32.0581 50.7681 31.7416 51.5322 31.5497 52.3315C31.3332 53.233 31.3332 54.191 31.3332 56.1069V62.6654Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork2);
export default __webpack_public_path__ + "static/media/work2.163fb0af24b055add9f8c5746b0ca7c5.svg";
export { ForwardRef as ReactComponent };